const mediaQueries = {
	sm: {
		min: 0,
		max: 767
	},
	md: {
		min: 768,
		max: 1199
	},
	lg: {
		min: 1200
	}
}

export default mediaQueries
